import React, { Component } from 'react';
import BotTagManagerEditBtn from '../EditBtn';

// Custom Option "Component" Reference for React-Select-Plus
//https://github.com/JedWatson/react-select/blob/v1.x/examples/src/components/CustomComponents.js

export class BotTagManagerOption extends Component {
  handleMouseDown(event) {
    event.preventDefault();
    event.stopPropagation();

    // Dont add when BotTagManagerEditBtn is clicked
    if (event.target.className.indexOf('BotTagManagerEditBtn') !== -1) return;

    this.props.onSelect(this.props.option, event);
  }

  renderEditBtn() {
    const option = this.props.option;
    const tag = option.tag;

    // Dont show when creating a new tag
    if (!tag) return null;

    return <BotTagManagerEditBtn tag={tag} />;
  }

  render() {
    return (
      <div
        {...this.props}
        role="option"
        onMouseDown={this.handleMouseDown.bind(this)}
      >
        <span className="BotTagManagerOption-text">{this.props.children}</span>
        {this.renderEditBtn()}
      </div>
    );
  }
}

export default BotTagManagerOption;
